import { render, staticRenderFns } from "./fidelior-home.vue?vue&type=template&id=6b67715c&"
import script from "./fidelior-home.vue?vue&type=script&lang=js&"
export * from "./fidelior-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports